import { render } from "./HeroLeaveStatus.vue?vue&type=template&id=39d336be&scoped=true"
import script from "./HeroLeaveStatus.vue?vue&type=script&lang=js"
export * from "./HeroLeaveStatus.vue?vue&type=script&lang=js"

import "./HeroLeaveStatus.vue?vue&type=style&index=0&id=39d336be&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d336be"]])

export default __exports__